/*
  ClaimViewPdf
*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import autoBind from 'react-autobind';
import classnames from 'classnames';
import { injectIntl } from 'react-intl';

import Alert from 'ui/common/alert';
import { pdfViewMessages } from './messages';
import Feedback from 'ui/claims/details/feedback';
import ClaimExportButton from 'ui/components/claim-export-button/loadable';
import FacebookShareButton from 'ui/components/facebook-share-button/loadable';
import TwitterShareButton from 'ui/components/twitter-share-button/loadable';
import LinkedinShareButton from 'ui/components/linkedin-share-button/loadable';
import FlaggedReasonsDisplay from 'ui/components/flagged-reasons-display/loadable';

import styles from './index.module.scss';
import ProgressChart from 'ui/common/charts/progress-chart';
// import PercentileCurve from '../details/percentileCurve';
import { processFlaggedReasons } from 'store/features/claims/helpers';
// import ExternalLink from 'ui/common/external-link';
import header from './header.png';

class ClaimReportView extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  static propTypes = {
    claim: PropTypes.object,
    isCurrentUserAdmin: PropTypes.bool,
    dataSets: PropTypes.arrayOf(PropTypes.object),
    noOfMinVotes: PropTypes.number,
    endorsedCount: PropTypes.number,
    flaggedCount: PropTypes.number,
    isUserCompanyAdmin: PropTypes.bool,
    isClaimOwnerProfileOwner: PropTypes.bool,
    showSocialShareButtons: PropTypes.bool,
    totalNumberOfVotes: PropTypes.number,
  };

  // renderClaimGeneralInfoPDF() {
  //   const { claim, intl: { formatMessage }, dataSets, endorsedCount, flaggedCount } = this.props;

  //   return (
  //     <div className="col-12">
  //       {(claim.type === 'BOAST' || !claim.type) &&
  //         (claim.desc && placeholderDescriptions.indexOf(claim.desc.toLowerCase()) < 0) && (
  //           <div className={classnames(styles.whiteShadedBox)}>
  //             <div className="row pb-1">
  //               <div className="col-12 pt-2 d-flex align-self-center">
  //                 {formatMessage(pdfViewMessages.description)}
  //               </div>
  //               <div className="col-12 pt-1 d-flex align-self-center">
  //                 <p
  //                   className="gray text-whitespace-pre-wrap pb-1"
  //                   dangerouslySetInnerHTML={{ __html: claim.desc.substring(0, 50) }} // Quick fix, i am sorry
  //                 />
  //               </div>
  //             </div>
  //           </div>
  //         )}

  //       {dataSets &&
  //         dataSets.length && (
  //           <div className={classnames(styles.whiteShadedBox, 'mt-3')}>
  //             <div className="row">
  //               {/* Recommended by 5 out of 6 Experts */}
  //               <div className="col-12 text-center">
  //                 <FormattedMessage
  //                   id="graphql.ClaimViewPdf.pdfViewMessages.recommendedByExperts"
  //                   defaultMessage="Recommended by {endorsedCount} out of {totalNumberOfVotes} Experts"
  //                   values={{
  //                     endorsedCount: endorsedCount,
  //                     totalNumberOfVotes: endorsedCount + flaggedCount,
  //                   }}
  //                 />
  //               </div>
  //               <div className="col-2 pt-3 d-flex align-self-center">
  //                 {formatMessage(pdfViewMessages.votesReceived)}
  //               </div>
  //               <div className="col-10 pt-3">
  //                 <ProgressChart labelLegend="Votes" dataSets={dataSets} />
  //               </div>
  //             </div>
  //           </div>
  //         )}
  //     </div>
  //   );
  // }

  // renderClaimantGeneralInfo() {
  //   const { claim, intl: { formatMessage }, isCurrentUserAdmin } = this.props;
  //   const { owner: user } = claim;

  //   const skillDisplayNames = this.getSkillDisplayNames();

  //   return (
  //     <div className={'col-12 px-5'}>
  //       <div className={'row justify-content-center'}>
  //         {user &&
  //           user.name && (
  //             <div className={classnames('col-md-6')}>
  //               <div className={classnames(styles.parentCell)}>
  //                 <a
  //                   className="pointer"
  //                   href={`${routeGenerators.users.vanityProfile(user)}`}
  //                   target="_blank"
  //                   rel="noopener noreferrer"
  //                 >
  //                   <div className={classnames(styles.childCell)}>
  //                     <Avatar
  //                       user={user}
  //                       size={70}
  //                       className={classnames('text-center', 'align-middle', 'mr-2')}
  //                       disableURL
  //                     />
  //                   </div>
  //                   <div className={classnames(styles.childCell, styles.wordWrap)}>
  //                     <div>{user.name}</div>
  //                     <div>@{user.username}</div>
  //                   </div>
  //                 </a>
  //               </div>
  //             </div>
  //           )}

  //         <div
  //           className={classnames({
  //             'col-md-6': user && user.name,
  //             'col-md-12': !(user && user.name),
  //           })}
  //         >
  //           <div className={classnames(styles.subTitle)}>
  //             {skillDisplayNames &&
  //               skillDisplayNames.length > 0 && (
  //                 <div className="d-flex d-inline-items pt-3">
  //                   <span className="gray">{formatMessage(pdfViewMessages.skill)}</span>

  //                   <span className="px-1">
  //                     <b>{skillDisplayNames.join(', ')}</b>
  //                   </span>
  //                 </div>
  //               )}

  //             {claim &&
  //               claim.level &&
  //               claim.level.name && (
  //                 <div className="d-flex d-inline-items pt-3">
  //                   <span className="gray">{formatMessage(pdfViewMessages.proficiencyLevel)}</span>
  //                   <span className="px-1">
  //                     <b>{claim.level.name}</b>
  //                   </span>
  //                 </div>
  //               )}
  //             {/* Show partner claim details, e.g cutshort.io */}
  //             {isCurrentUserAdmin &&
  //               claim.company &&
  //               claim.company.companyName && (
  //                 <div className="table-row ml-auto">
  //                   <div className="table-cell pt-3">
  //                     <span className="gray">
  //                       {formatMessage(pdfViewMessages.claimPartnerName)}
  //                     </span>
  //                   </div>
  //                   <div className="table-cell pl-3 pt-3">
  //                     <b>{claim.company.companyName}</b>
  //                   </div>
  //                 </div>
  //               )}
  //           </div>
  //         </div>
  //       </div>

  //       {/* Show repo link as requested by cutshort.io */}
  //       {claim.proof && (
  //         <div className={classnames(styles.subTitle, 'row pb-2')}>
  //           <div className="col-12 pt-3 d-flex align-self-center">
  //             <span className="gray">{formatMessage(pdfViewMessages.repositoryLink)}</span>
  //           </div>
  //           <div className="col-12 d-flex align-self-center">
  //             <b>
  //               <ClaimProof claimId={claim.id} claimProof={claim.proof} />
  //             </b>
  //           </div>
  //         </div>
  //       )}
  //     </div>
  //   );
  // }

  renderPDFViewTypeBoast() {
    // ID-1470: HUGE assumption, only show with print-friendly view.
    const { claim, noOfMinVotes, dataSets } = this.props;

    return (
      <div className={classnames('container pb-5 mt-2', styles.printWidth, styles.whiteShadedBox)}>
        <div id="export-pdf-content-1">
          <div className="row pb-4">
            <div>
              <img src={header} alt="header" height="100px" />
            </div>

            <div className="col-5 ml-5 pt-3 font-weight-bold">
              <h3 style={{ fontSize: '28px', color: '#313f4c', lineHeight: '28px' }}>
                {claim.module
                  ? claim.module.candidateName.toUpperCase()
                  : claim.claimant.name.toUpperCase()}
              </h3>

              <h3 className="text-uppercase" style={{ color: '#313f4c' }}>
                Personalised Skills Report
              </h3>
            </div>
          </div>
          {/* <div className={classnames('row', styles.greyBackground)}>
            <div className={classnames(styles.greyShadedBox, 'col-12 px-5 text-center')}>
              <div style={{ fontSize: '34px' }}>{claim.company.companyName}</div>
            </div>
          </div> */}
          <div className="row ml-1">
            <div style={{ fontSize: '21px' }} className={classnames(styles.greyShadedBox)}>
              Course Name :
            </div>
          </div>
          <div
            className="row col-12 pt-4 font-weight-bold ml-1"
            style={{
              fontSize: '14px',
              color: '#34495e',
              textDecoration: 'none',
              wordBreak: 'break-all',
            }}
          >
            {/* <ExternalLink href={claim.proof} openInNewTab>
              {claim.proof}
            </ExternalLink> */}
            Go Microservices I
          </div>

          <div className="row ml-1 mt-1">
            <div style={{ fontSize: '21px' }} className={classnames(styles.greyShadedBox, 'mt-4')}>
              Repository Link :
            </div>
          </div>

          <div
            className="row col-12 pt-4 font-weight-bold pb-4 ml-1"
            style={{
              fontSize: '14px',
              color: '#34495e',
              textDecoration: 'none',
              wordBreak: 'break-all',
            }}
          >
            {/* <ExternalLink href={claim.proof} openInNewTab>
              {claim.proof}
            </ExternalLink> */}
            Publicly Inaccessible
          </div>

          <div className="row ml-1 pt-1">
            <div style={{ fontSize: '21px' }} className={classnames(styles.greyShadedBox)}>
              Votes Received :
            </div>
          </div>

          <div>
            {dataSets &&
              dataSets.length && (
                <div className={classnames('mt-3')}>
                  <div className="row">
                    <div className="col-8 offset-sm-1 pt-3">
                      <ProgressChart labelLegend="Votes" dataSets={dataSets} />
                    </div>
                  </div>
                </div>
              )}
          </div>

          <div className={classnames('row justify-content-center')}>
            <div className="col-12">
              <div className={classnames('mt-3')}>
                {claim.feedback &&
                  !!noOfMinVotes && (
                    <Feedback
                      id="feedback-section"
                      className="mx-auto"
                      claim={claim}
                      feedback={claim.feedback}
                      isPrintView={true}
                      showOnly="starRatings"
                    />
                  )}
              </div>
            </div>
          </div>
        </div>

        {this.moreThanXComments(0) && this.renderCommentsPage('export-pdf-content-2', 0, 4)}
        {this.moreThanXComments(4) && this.renderCommentsPage('export-pdf-content-3', 4, 7)}
        {this.moreThanXComments(7) && this.renderCommentsPage('export-pdf-content-4', 7, 10)}
      </div>
    );
  }

  moreThanXComments(x) {
    const { claim } = this.props;
    return (
      claim.feedback &&
      claim.feedback.explanation &&
      claim.feedback.explanation.filter(exp => {
        return exp && !exp.isCommentHidden;
      }).length > x
    );
  }

  // renderPercentileCurve() {
  //   const { claim } = this.props;

  //   return (
  //     <div className="col-12">
  //       <div className={classnames(styles.whiteShadedBox, 'mt-3')}>
  //         <PercentileCurve claim={claim} showBottomText />
  //       </div>
  //     </div>
  //   );
  // }

  renderCommentsPage(divId, startCommentIndex, endCommentIndex) {
    const { claim, noOfMinVotes } = this.props;

    return (
      <div className={classnames('row justify-content-center py-3')} id={divId}>
        {/* {this.renderClaimantGeneralInfo()} */}
        <div className="col-12">
          <div className={classnames('mt-3')}>
            {claim.feedback &&
              !!noOfMinVotes && (
                <Feedback
                  id="feedback-section"
                  className="col-12 mx-auto"
                  claim={claim}
                  feedback={claim.feedback}
                  isPrintView={true}
                  startCommentIndex={startCommentIndex}
                  endCommentIndex={endCommentIndex}
                  showOnly="textFeedback"
                />
              )}
          </div>
        </div>
      </div>
    );
  }

  renderPDFView() {
    const { claim } = this.props;

    if (claim.type === 'BOAST' || !claim.type) {
      return this.renderPDFViewTypeBoast();
    }
  }

  /*
    ID-1862 Show red box in page 1 if one validator flag plagiarism
  */

  renderReportedReasons() {
    const { claim } = this.props;
    const processedReasons = processFlaggedReasons(claim.flaggedReasonType);
    if (processedReasons.length) {
      return (
        <div className="col-12">
          <Alert className="color-light-red" closeBtn={false}>
            <span>
              <FlaggedReasonsDisplay
                flaggedReasonType={claim.flaggedReasonType}
                displayView="pureText"
              />
            </span>
          </Alert>
        </div>
      );
    }

    return null;
  }

  /* ID-1824 Let people share report pdf link on social media */
  renderSocialShareButtons() {
    const finalUrlToShare = `${window.location.href}`;

    return (
      <div className="ml-2">
        <FacebookShareButton
          className="mr-2"
          quote={`
            Here it is! My very own Code Report by Indorse!
            #Coding #Programming
            `}
          hashtag="#indorse"
          href={`${finalUrlToShare}?utm_source=Facebook_Button&utm_content=Coding_Skill_Report_Facebook_Button`}
        />

        <LinkedinShareButton
          className="mr-2"
          contentToShare={`
Here it is! My very own #Code Report by #Indorse!
#Coding #Programming
${finalUrlToShare}?utm_source=LinkedIn_Button&utm_content=Coding_Skill_Report_LinkedIn_Button
          `}
        />

        <TwitterShareButton
          contentToShare={`I just received my #Code Report by @joinindorse! This is only the beginning! 🚀`}
          url={`${finalUrlToShare}?utm_source=Twitter_Button&utm_content=Coding_Skill_Report_Twitter_Button`}
          hashtags={'Coding,Programming,Indorse'}
        />
      </div>
    );
  }

  renderAdminPDFController() {
    const { claim, intl: { formatMessage } } = this.props;

    // if (!isCurrentUserAdmin && !isUserCompanyAdmin && !isClaimOwnerProfileOwner) return null;

    let divIDsToExport;
    if (claim.type === 'ASSIGNMENT') {
      divIDsToExport = ['export-pdf-content-1', 'export-pdf-content-2', 'export-pdf-content-3'];
      if (this.moreThanXComments(4)) {
        divIDsToExport.push('export-pdf-content-4');
      }

      if (this.moreThanXComments(7)) {
        divIDsToExport.push('export-pdf-content-5');
      }
    } else if (claim.type === 'BOAST' || !claim.type) {
      divIDsToExport = ['export-pdf-content-1', 'export-pdf-content-2'];
      if (this.moreThanXComments(4)) {
        divIDsToExport.push('export-pdf-content-3');
      }

      if (this.moreThanXComments(7)) {
        divIDsToExport.push('export-pdf-content-4');
      }
    }

    return (
      <div className={classnames('container', styles.printWidth)}>
        <div className={classnames('d-flex justify-content-end mt-3')}>
          <ClaimExportButton divIDsToExport={divIDsToExport} fileName={`claim-${claim.id}`}>
            {formatMessage(pdfViewMessages.generatePDF)}
          </ClaimExportButton>
        </div>
      </div>
    );
  }

  render() {
    const { claim } = this.props;

    // Very important, without claim all render functions will not work
    if (!claim) return null;

    return (
      <div className={classnames('container py-4')}>
        {this.renderAdminPDFController()}
        {this.renderPDFView()}
      </div>
    );
  }
}

export default injectIntl(ClaimReportView);



// WEBPACK FOOTER //
// ./src/ui/claims/report-view/index.js